import {createAction} from 'redux-actions';

export const setAds = createAction('SET_ADS');

export const hideAds = createAction('HIDE_ADS');
